import gql from 'graphql-tag'
import {
	AuthenticationUserFragment,
	UserProfileFragment,
	// UserProfileArticlesFragment,
} from 'store/fragments'

// Queries
export const UserQuery = gql`
	query userQuery($id: String, $uid: String) {
		 userCollection(
    first: 1
    filter: {or :[
      {id: {eq:$id}}
      {uid :{eq:$uid}}
    ]}
  ) {edges{node{
			...AuthenticationUser}}
		}
	}
	${AuthenticationUserFragment}
	${UserProfileFragment}
`

export const UserProfileQuery = gql`
	query userProfile($uid: String!) {
		 profileCollection(
    first: 1
    filter: {id:{eq: $uid}}
  ) {
			edges{node{...UserProfileFragment}}
		}
	}
	${AuthenticationUserFragment}

	${UserProfileFragment}
`
export const UsersProfileQuery = gql`
	query usersProfile($data: String) {
		userCollection(
    first: 1
    filter: {uid:{eq: $data}}
  ) {
			edges{node{...AuthenticationUser}}
		}
	}
	${AuthenticationUserFragment}

	${UserProfileFragment}
`

export const UserProfilesByNameQuery = gql`
	query userProfilesByName($UserName: String) {
		profileCollection(
    first: 15
    orderBy: {userName: AscNullsLast}
    filter: {userName:{ilike:$UserName}}
  ) {
			edges{node{...UserProfileFragment}}
		}
	}
	
	${UserProfileFragment}
`

export const UserProfilesByEmailQuery = gql`
	query userProfilesByEmail($email: String) {
		userCollection(
    first: 15
    orderBy: {email:AscNullsLast}
    filter: {
      email:{ilike: $email}
    }
  ) {
			edges{node{...AuthenticationUser}}
		}
	}
	${AuthenticationUserFragment}

	${UserProfileFragment}
`

// export const UserProfileArticlesQuery = gql`
// 	query userProfileArticles($uid: String!) {
// 		profileCollection(filter: { id: {eq:$uid} }) {
// 			...UserProfileArticles
// 		}
// 	}
// 	${UserProfileArticlesFragment}
// `

export const CheckUsername = gql`
	query checkusername($uid: String!) {
	 userCollection(
    first: 1
    filter: {uid:{eq: $uid}}
  ){
    edges{node{status}}
  }
	}
`

export const CheckEmail = gql`
	query checkEmail($filter:  UserFilter) {
		userCollection(filter: $filter) {
			edges{node{status}}
		}
	}
`

// MUATTIONS

export const UpdateProfileDetails = gql`
	mutation updateProfileDetails($details:  [ProfileInsertInput!]!) {
		insertIntoProfileCollection(objects: $details) {
			records{...UserProfileFragment}
		}
	}
	${AuthenticationUserFragment}
	${UserProfileFragment}
`

export const UpdateUserValues = gql`
	mutation setValues($values: [String!]!, $userId: String!) {
		setvalues(valuetitles: $values, userid: $userId) {
			edges{node{...UserProfileFragment}}
		}
	}
	${UserProfileFragment}
`
export const UpdateUserSkills = gql`
	mutation setSkills($skills: [String!]!) {
		setskills(skills: $skills) {
		edges{
      node{
        id
        title
      }
    }
		}
	}
`
export const UpdateUsername = gql`
	mutation updateUsername($userId: String, $username: String!) {
		updateUserCollection(
    filter: {id: {eq: $userId}}
    set: {uid: $username}
  ){ affectedCount
    records{
      id
      uid
    }
		}
	}
`
//todo
export const SendUpdateEmail = gql`
	mutation sendUpdateEmailLink(
		$language: LanguageCodeType!
		$newEmail: String!
	) {
		sendUpdateEmailLink(language: $language, newEmail: $newEmail) {
			status
			error
		}
	}
 `
// //todo
export const ConfirmUpdateEmail = gql`
	mutation updateEmail($token: String!) {
		updateEmail(token: $token) {
			...AuthenticationUser
		}
	}
	${AuthenticationUserFragment}
	${UserProfileFragment}
`
export const UpdateUserSettings = gql`
	mutation updateUserSettings($userID: String ,$userSettings: ProfileUpdateInput!) {
		updateProfileCollection(
			filter:{user:{eq:$userID}}
			set: $userSettings
			) {
			records{...UserProfileFragment}
		}
	}
	${AuthenticationUserFragment}
	${UserProfileFragment}
`
export const SetUpProfile = gql`
	mutation setUpProfile($profileId: String!
$firstName: String
$lastName: String
$aboutMe: String
$avatarPath: String
$coverPath: String
$skills: [String]
$values: [String]
$locationId: String
$cvFilePath: [String]
$cvFileOriginalName: [String]) {
		setUpProfile(
			profileId:$profileId
firstName:$firstName
lastName:$lastName
aboutMe:$aboutMe
avatarPath:$avatarPath
coverPath:$coverPath
skills:$skills
values:$values
locationId:$locationId
cvFilePath:$cvFilePath
cvFileOriginalName:$cvFileOriginalName
		) {edges{node{
			...AuthenticationUser}}
		}
	}
	${AuthenticationUserFragment}
	${UserProfileFragment}
`
export const SetCVFile = gql`
	mutation setCVFile($cvFilePath: JSON, $cvFileOriginalName: JSON) {
		updateProfileCollection(set:{
			cvFilePath: $cvFilePath
			cvFileOriginalName: $cvFileOriginalName}
		) {
			records{...UserProfileFragment}
		}
	}
	${AuthenticationUserFragment}
	${UserProfileFragment}
`
export const SetUserOnBoarding = gql`
	mutation setUserOnBoarding
	# ($language: LanguageCodeType!)
		 {
		insertIntoProfileCollection(objects:{
			userOnBoardingFormVisited: true
		}) {
			records{
			amount
			}
		}
	}
`
